import { isString } from "@/utils";
import { equals } from "ramda";
interface ObservedAttributes {
  classname: string;
  value: string;
  disabled: string;
}
export class Textarea extends HTMLTextAreaElement {
  constructor() {
    super();
    this.addEventListener("blur", this.#hdInput);
  }
  static get observedAttributes() {
    return ["classname", "value", "disabled"];
  }
  #hdInput() {
    if (this.value && isString(this.value)) {
      const value = this.value.trim();
      if (!equals(value, this.value)) {
        this.value = value;
        this.dispatchEvent(
          new Event("input", {
            bubbles: true,
            cancelable: true,
          }),
        );
      }
    }
  }
  #updateClass() {
    const classname = this.getAttribute("classname");
    if (classname) {
      this.className = classname;
    }
  }
  #updateDisabled() {
    const disabled = this.getAttribute("disabled");
    if (disabled) {
      this.disabled = equals(disabled, "true");
    }
  }
  attributeChangedCallback(type: keyof ObservedAttributes) {
    switch (type) {
      case "classname":
        this.#updateClass();
        break;
      case "value":
        this.#hdInput();
        break;
      case "disabled":
        this.#updateDisabled();
    }
  }
  disconnectedCallback() {
    this.removeEventListener("blur", this.#hdInput);
  }
}

export function define(name = "r-textarea") {
  if (customElements.get(name)) return;
  customElements.define(name, Textarea, { extends: "textarea" });
}
